<template>
  <el-dialog v-loading="isLoading" :title="title" :visible.sync="dialogFormVisible" top="2vh" width="50vw"
    element-loading-text="加载中" @close="close" class="fixed-header-footer-dialog">
    <div class="dialog-content-wrapper">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" class="scrollable-form">
        <el-form-item label="所属用户">
          <div class="user-info">
            <span>{{ form.username || '-' }}</span>
            <span class="user-code">{{ form.user_code ? `(${form.user_code})` : '' }}</span>
          </div>
        </el-form-item>

        <el-form-item v-if="form.express_code" label="韩国单号">
          <el-input v-model.trim="form.express_code"></el-input>
        </el-form-item>

        <!-- 所属状态 -->
        <el-form-item label="订单状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="form.refuse_remark" label="驳回理由">
          <el-input v-model.trim="form.refuse_remark"></el-input>
        </el-form-item>

        <el-form-item :label="daifu ? '平台链接' : '物品链接'">
          <el-input v-model.trim="form.link" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
        </el-form-item>

        <el-form-item v-if="daifu" label="平台账号">
          <el-input v-model.trim="form.account"></el-input>
        </el-form-item>

        <el-form-item v-if="daifu" label="账号密码">
          <el-input v-model.trim="form.password"></el-input>
        </el-form-item>

        <el-form-item label="物品名称">
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>

        <el-form-item label="物品款式">
          <el-input v-model.trim="form.style"></el-input>
        </el-form-item>

        <el-form-item label="物品数量">
          <el-input v-model.trim="form.num" maxlength="10" show-word-limit></el-input>
        </el-form-item>

        <el-form-item v-if="form.pay_status == 0" label="物品总金额" prop="price">
          <el-input v-model.trim="form.price" maxlength="8" show-word-limit @input="handleInputPrice('price')"></el-input>
        </el-form-item>

        <el-form-item v-if="form.pay_status == 1" label="物品总金额" prop="total_price">
          <el-input v-model.trim="form.total_price" maxlength="8" show-word-limit @input="handleInputPrice('total_price')"></el-input>
        </el-form-item>

        <el-form-item v-if="form.user_balance > 0" label="使用余额">
          <el-input v-model.trim="form.user_balance" disabled></el-input>
        </el-form-item>

        <el-form-item v-if="form.price > 0 && form.status > 1" label="现金支付">
          <el-input v-model.trim="form.price" disabled></el-input>
        </el-form-item>

        <el-form-item label="申请时间" prop="add_time">
          <el-input v-model.trim="form.add_time" disabled></el-input>
        </el-form-item>

        <!-- 退款类型：pay_status == 3 部分退款，pay_status == 2 全部退款 -->
        <el-form-item v-if="form.pay_status == 2 || form.pay_status == 3" label="退款类型">
          <el-input :value="refundTypeText" disabled></el-input>
        </el-form-item>

        <el-form-item v-if="form.refund_price > 0 && form.status > 1" label="退款金额">
          <el-input v-model.trim="form.refund_price" disabled></el-input>
        </el-form-item>

        <el-form-item v-if="form.remark" label="订单备注">
          <el-input v-model.trim="form.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
        </el-form-item>

        <el-form-item v-if="form.order_pay_refund && form.order_pay_refund.length > 0" label="客服退款备注">
          <div v-for="(item, index) in form.order_pay_refund" :key="item.id || index">
            <el-input v-model.trim="item.refund_remarks" disabled type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
          </div>
        </el-form-item>

        <el-form-item v-if="form.pic" label="物品图片">
          <el-image v-for="(item, index) in srcList" :key="index"
            style="width: 100px; height: 100px; margin-right: 10px" :src="item" :preview-src-list="srcList"></el-image>
        </el-form-item>

        <el-form-item label="给客户提供反馈">
          <el-input v-model.trim="form.feedback" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
        </el-form-item>

      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { buyDetail, buyUpdate } from '@/api/xgcApi'

export default {
  name: 'UserManagementEdit',
  components: {},
  data() {
    return {
      form: {
        id: '',
        username: '',
        user_code: '',
        express_code: '',
        status: '',
        pay_status: '',
        refuse_remark: '',
        link: '',
        account: '',
        password: '',
        name: '',
        style: '',
        user_balance: 0,
        num: '',
        price: '',
        total_price: '',
        refund_price: '',
        add_time: '',
        remark: '',
        order_pay_refund: [],
        pic: '',
        feedback: ''
      },
      title: '',
      srcList: [],
      dialogFormVisible: false,
      isLoading: false,
      rules: {
        price: [
          { required: true, trigger: 'blur', message: '请输入物品金额' },
        ],
      },
      daifu: false,
      statusList: [
        { value: 0, label: '待审核' },
        { value: 1, label: '待支付' },
        { value: 2, label: '代采购' },
        { value: 8, label: '已采购' },
        { value: 3, label: '已入库' },
        { value: 5, label: '已取消' },
        { value: 6, label: '退款中' },
        { value: 7, label: '已退款' },
        { value: 9, label: '已驳回' },
      ],
    }
  },
  computed: {
    // pay_status == 2 全部退款，pay_status == 3 部分退款
    refundTypeText() {
      const map = { 2: '全部退款', 3: '部分退款' }
      return map[Number(this.form.pay_status)] || '-'
    }
  },
  methods: {
    // 支持按字段过滤金额，避免 total_price 输入时污染 price
    handleInputPrice(field = 'price') {
      const value = this.form[field]
      if (!value) return
      this.form[field] = value
        .replace(/[^\d.]/g, '')
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },

    async showEdit(row) {
      this.daifu = row.type === 2
      this.srcList = []
      this.dialogFormVisible = true
      this.title = '编辑'
      this.isLoading = true

      try {
        const { data } = await buyDetail({ id: row.id })
        this.form = {
          ...this.form,
          ...data,
          order_pay_refund: data.order_pay_refund || []
        }

        if (data.pic) {
          this.srcList = data.pic.split(',')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        this.$message.error('获取详情失败')
      } finally {
        this.isLoading = false
      }
    },

    close() {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.form = {
          id: '',
          username: '',
          user_code: '',
          express_code: '',
          status: '',
          pay_status: '',
          refuse_remark: '',
          link: '',
          account: '',
          password: '',
          name: '',
          style: '',
          user_balance: 0,
          num: '',
          price: '',
          total_price: '',
          refund_price: '',
          add_time: '',
          remark: '',
          order_pay_refund: [],
          pic: '',
          feedback: ''
        }
        this.srcList = []
        this.isLoading = false
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.isLoading = true
            const { msg } = await buyUpdate(this.form)
            this.$baseMessage(msg, 'success')
            this.$emit('fetch-data')
            this.close()
          } catch (error) {
            console.error('保存失败:', error)
            // this.$message.error('保存失败')
          } finally {
            this.isLoading = false
          }
        }
      })
    },
  },
}
</script>

<style scoped>
/* 弹窗固定头部和尾部，中间滚动 */
:deep(.fixed-header-footer-dialog .el-dialog) {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

:deep(.fixed-header-footer-dialog .el-dialog__header) {
  flex-shrink: 0;
  border-bottom: 1px solid #e8e8e8;
  padding: 20px 20px 15px;
}

:deep(.fixed-header-footer-dialog .el-dialog__body) {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px;
  height: 76vh;
}

:deep(.fixed-header-footer-dialog .el-dialog__footer) {
  flex-shrink: 0;
  border-top: 1px solid #e8e8e8;
  padding: 15px 20px 20px;
}

/* 内容包裹器 - 负责滚动 */
.dialog-content-wrapper {
  height: 100%;
  overflow-y: auto;
  padding-right: 5px;
}

/* 美化滚动条 */
.dialog-content-wrapper::-webkit-scrollbar {
  width: 6px;
}

.dialog-content-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 表单样式 */
.scrollable-form {
  padding-bottom: 10px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  height: 40px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #606266;
}

.user-code {
  color: #909399;
  font-size: 13px;
}

/* 取消el-form-item的底部边距，由滚动控制 */
:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.el-form-item:last-child) {
  margin-bottom: 0;
}

/* 图片样式 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>